/** basic-legend-item */

<template>
    <div>
        <div class="additional-layers-control" v-on:click.prevent="showLayers = !showLayers">
            <span>Additional Activity Data</span>
            <span>{{ showHideText }}</span>
        </div>

        <div class="additional-layers-container" v-if="showLayers">
            <div v-for="layer in additionalActivityLayers">
    <!--        uses the json field to create a multi-style legend item    -->
                <div class="legend-item-with-title" v-if="layer.legend_below_title && layer.mparc_legend">
                    <div>
                        <label>
                            <input type="checkbox" class="legend-checkbox"
                               v-bind:id="layer.layer_name" v-if="layer.allow_control" v-bind:checked="layer.layer_enabled"
                               v-on:change="toggleActivityLayer($event, layer.layer_name)"/>
                            {{ layer.layer_name_display }}
                        </label>
                    </div>

                    <div v-bind:id="'lg' + layer.layer_name" style="display: none">  <!-- dynamic id for grabbing below when hiding/showing -->
                        <div v-for="legendItem in layer.mparc_legend.legendItems" class="json-legend-below-title">
                            <div><div v-bind:style="legendItem.style" class="base-custom-leaflet-legend-style"></div></div>
                            <div>{{legendItem.category_name}}</div>
                        </div>
                    </div>

                </div>

    <!--        uses the styles field or original legend item to create a single style legend item    -->
                <div class="basic-legend-item" v-if="!layer.legend_below_title">
                    <div>
                        <input type="checkbox" class="legend-checkbox"
                               v-bind:id="layer.layer_name" v-if="layer.allow_control" v-bind:checked="layer.layer_enabled"
                               v-on:change="toggleActivityLayer($event, layer.layer_name)"/>
                    </div>

                    <div>
                        <img v-if="!layer.leaflet_styles" v-bind:src="layer.legend_graphic" alt="">

                        <div v-if="layer.leaflet_styles">
                            <div v-bind:style="layer.leaflet_legend_styles" class="base-custom-leaflet-legend-style"></div>
                        </div>
                    </div>

                    <div><label v-bind:for="layer.layer_name">{{ layer.layer_name_display }}</label></div>
                </div>

<!--            use the existing legend stuff to render other bits    -->
<!--                <legend-with-title v-bind:layer="layer" v-on:layer-change="toggleActivityLayer($event, layer.layer_name)"/>-->
                <div class="legend-item-with-title" v-if="layer.legend_below_title && !layer.mparc_legend">
                    <div>
                        <label>
                            <input type="checkbox" class="legend-checkbox"
                               v-bind:id="layer.layer_name" v-if="layer.allow_control" v-bind:checked="layer.layer_enabled"
                               v-on:change="toggleActivityLayer($event, layer.layer_name)"/>
                            {{ layer.layer_name_display }}
                        </label>
                    </div>

                    <div class="legend-item-below-title" v-bind:id="'lg' + layer.layer_name" style="display: none">  <!-- dynamic id for grabbing below when hiding/showing -->
                        <div><img v-bind:src="layer.legend_graphic" alt=""></div>
                        <div v-if="layer.legend_additional_text" v-html="layer.legend_additional_text" style="line-height: normal"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import store from "../store/reality-check-store";
import LegendWithTitle from "./legend-with-title.vue";

export default {
    name: "additional-activities-legend",
    components: {LegendWithTitle},
    store,
    props: {},
    data: function () {
        return {
            showLayers: false
        }
    },
    methods: {
        toggleActivityLayer: function (e, layerName) {
            this.$store.commit("toggleActivitiesMapLayer",
                [layerName, e.target.checked])

            if (e.target.checked) {
                if (layerName === "aa-disposal-sites" || layerName === "aa-imo-routeing-areas") {
                    // using original code, should really tidy this up...
                    document.getElementById("lg" + layerName).style.display = "flex"
                } else {
                    document.getElementById("lg" + layerName).style.display = "block"
                }

            } else {
                document.getElementById("lg" + layerName).style.display = "none"
            }
        }
    },
    computed: {
        additionalActivityLayers: function () {
            return this.$store.state.additionalActivityLegendLayers
        },
        showHideText: function () {
            if (this.showLayers) {
                return "Hide"
            }
            return "Show"
        }
    },
    watch: {},
    mounted: function () {
        // enable any layers that are start_enabled, needs small delay to allow store to finish creating stuff - todo: why isn't this happening after promise resolves?
        window.setTimeout(function () {
            this.$nextTick(function () {
                for (const layer in this.additionalActivityLayers) {
                    if (this.additionalActivityLayers[layer].layer_enabled) {
                        this.$store.commit("toggleActivitiesMapLayer",
                            [layer, true])
                    }
                }
            });

        }.bind(this), 500);
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .basic-legend-item {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 5px;

        div:first-of-type, div:nth-of-type(2) {
            display: flex;
            flex: 0 0 20px;
            align-items: center;
        }

        div:nth-of-type(2) {
            margin-right: 4px;
        }
    }

    .base-custom-leaflet-legend-style {
        flex: none !important;
        width: 13px;
        height: 11px;
        margin: auto;
    }

    .json-legend-below-title {
        display: flex;
        justify-content: flex-start;
        margin-top: 2px;

        > div:first-of-type {
            display: flex;
            flex: 0 0 20px;
            margin: 0 5px 0 20px;
        }
    }

    .additional-layers-container {
        margin-left: 3px;
        font-size: 90%;
    }

    .additional-layers-control {
        cursor: pointer;

        > span:first-of-type {
            font-weight: bold;
        }
        > span:nth-of-type(2) {
            font-style: italic;
            text-decoration: underline;
        }
    }
</style>